import ElementUI from 'element-ui';
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';
// import "@/assets/less/base.less";
// import rules from '@/rule'
// import api from "@/api"
// import 'animate.css';

Vue.config.productionTip = false
// Vue.use(rules)
Vue.use(ElementUI)
// Vue.use(api)
Vue.directive('title', {
    inserted: function (el) {
      document.title = el.dataset.title
    }
  })
  